import { render, staticRenderFns } from "./BaseChart.vue?vue&type=template&id=451ffb48&scoped=true"
import script from "./BaseChart.vue?vue&type=script&lang=ts"
export * from "./BaseChart.vue?vue&type=script&lang=ts"
import style0 from "./BaseChart.vue?vue&type=style&index=0&id=451ffb48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451ffb48",
  null
  
)

export default component.exports